import React from "react";

interface Props {
  className?: string;
  rotate?: "top" | "right" | "bottom" | "left";
}

const rotationDegrees: Record<NonNullable<Props["rotate"]>, number> = {
  top: -90,
  right: 0,
  bottom: 90,
  left: 180,
};

const Caret: React.FC<Props> = ({ className, rotate = "bottom" }) => {
  const rotation = rotationDegrees[rotate];

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <path
        d="M3.56708 11.8008L4.59958 12.8333L10.4329 6.99999L4.59958 1.16666L3.56708 2.19916L8.36791 6.99999L3.56708 11.8008Z"
        fill="var(--icon)"
      />
    </svg>
  );
};

export default Caret;
